import { get } from "@/api/axios";

/**
 * 1. 数据看板概览统计
 * 包含合作伙伴总数、总学习时长、总浏览量、活跃合作伙伴数等
 * 
 * @param {Object} params - 查询参数包含 startTime, endTime
 * @returns {Promise<Object>}
 */
export function getDashboardStatistics(params) {
  return get("/web/dashboard/statistics", params);
}

/**
 * 2. 视频课程播放量 Top10
 * 
 * @param {Object} params - 查询参数包含 startTime, endTime
 * @returns {Promise<Object>}
 */
export function getCoursePlayTop10(params) {
  return get("/web/dashboard/course/play/top10", params);
}

/**
 * 3. 手册下载率 Top10
 * 
 * @param {Object} params - 查询参数包含 startTime, endTime
 * @returns {Promise<Object>}
 */
export function getManualDownloadRateTop10(params) {
  return get("/web/dashboard/manual/download/rate/top10", params);
}

/**
 * 4. 新闻及产品公告浏览量 Top10
 * 
 * @param {Object} params - 查询参数包含 startTime, endTime
 * @returns {Promise<Object>}
 */
export function getNewsViewTop10(params) {
  return get("/web/dashboard/news/view/top10", params);
}

/**
 * 5. 合作伙伴学习时长与浏览量统计列表
 * 
 * @param {Object} params - 查询参数包含 startTime, endTime, page, size
 * @returns {Promise<Object>}
 */
export function getStudyDurationViewStatisticsList(params) {
  return get("/web/dashboard/study/duration/view/statistics/list", params);
}

/**
 * 6. 用户登录记录-分页查询
 * 
 * @param {Object} params - 查询参数包含 startTime, endTime, page, size
 * @returns {Promise<Object>} 接口返回 Promise 对象
 */
export function getMemberLoginRecordList(params) {
  return get("/web/dashboard/member/login/record/list", params);
}

/**
 * 7. 合作伙伴与良信员工学习时长及浏览量统计合计
 * 
 * @param {Object} params - 查询参数包含 startTime, endTime
 * @returns {Promise<Object>} 接口返回 Promise 对象
 */
export function getStudyDurationViewStatisticsTotal(params) {
  return get("/web/dashboard/study/duration/view/statistics/total", params);
}

